/* eslint-disable */
import { useState, Fragment, useRef } from 'react';

import { useLogDetail } from '../api.js'

export default function ExtraBox({flow_id, detailData}) {
    const reportPre = useLogDetail(flow_id,detailData.run_id);

    if (reportPre.isPending) {
        return <p>Loading....</p> // <Spinner />
    }
    if (reportPre.isError) {
        // if (error != null) {
        //     if (error.response.status == '401') noAuth()
        // }
    }


     const LeftBlock = ({ leftDatas }) => {
        const item = JSON.parse(leftDatas.extra_api)
        if (leftDatas.type == "whatsapp") {

            if (leftDatas.whatsapp_type == "interactive") {
                const ButtonFunc = ({ i }) => {
                    const main_arr = JSON.parse(leftDatas.interactive_btn)
                    if (!main_arr || main_arr == null) {
                        console.log(leftDatas)
                        return;
                    }
                    return main_arr.map((x, sec_ind) => {
                        if (leftDatas.interactive_type == "list") {
                            return (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='flex mb-2'>
                                            <div className="Button_div_box ">
                                                <p> {x.row_title}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        } else if (leftDatas.interactive_type == "button") {
                            return (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='flex mb-2'>
                                            <div className="Button_div_box ">
                                                <p> {x.title}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    })
                }

                const header_fun = (i) => {
                    if (i.header_data != "" && i.header_data != null) {
                        if (i.header_type == "text") {
                            return (
                                <div className="header_teml">
                                    <label className="header_heading"> <i className="fa-solid fa-tachograph-digital"></i> Header</label>
                                    <div className="header_enter_text_box">
                                        <p>{i.header_data}</p>
                                    </div>
                                </div>
                            )
                        } else if (i.header_type == "image") {
                            return (
                                <div className="header_teml">
                                    <label className="header_heading"> <i className="fa-solid fa-tachograph-digital"></i> Header</label>
                                    <div className="header_enter_text_box">
                                        <div className="img-fluid">  <img src={i.header_data} alt="WA Header Image" /> </div>
                                    </div>
                                </div>
                            )
                        }
                    }
                }

                const footer_fun = (i) => {
                    if (i.footer != "" && i.footer != null) {
                        return (
                            <div className="footer_teml mt-2">
                                <label className="header_heading"> <i className="fa-solid fa-table-list"></i> Footer</label>
                                <div className="footer_enter_text_box">
                                    <p>{i.footer}</p>
                                </div>
                            </div>
                        )
                    }
                }

                return (
                    <div className="left_box_main">
                        <div className="main_flex_div">
                            <div className="card position-relative p-0 box_width h-lg-100">
                                <div className="card-body mt-0 ">
                                    {header_fun(item)}
                                    <div className="body_teml mt-1 mb-1">
                                        <label className="header_heading"> <i className="fa-solid fa-file-lines"></i> Body</label>
                                        <div className="body_enter_text_box">
                                            <p>{item.body}</p>
                                        </div>
                                    </div>
                                    {footer_fun(item)}
                                    <div className="line_ashish"> </div>
                                    <div className="Button_teml">
                                        <ButtonFunc i={item} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } else if (leftDatas.whatsapp_type == "template") {
                return (
                    <Fragment>
                        {leftDatas.parent}
                    </Fragment>
                )
            }
        } else if (leftDatas.type == "wa_message") {
            return (
                <div className="left_box_main">
                    <div className="main_flex_div">
                        <div className="card position-relative p-0 box_width w-auto h-auto">
                            <div className="card-body mt-0 ">{item.data}</div>
                        </div>
                    </div>
                </div>
            )
        }  
    }


    const RightBlock = ({ rightDatas }) => {
        const item = JSON.parse(rightDatas.extra_api)
        const newItem = JSON.parse(rightDatas.interactive_btn)

        if (rightDatas.interactive_type == "list") {
            return newItem.map(j => {
                if (j.row_id == rightDatas.btn_id) {
                    return (
                        <div className="right_meg_box_new">
                            <div className="repley_box">
                                <div className="repley_data">
                                    <p>{item.body}</p>
                                </div>
                                <div className="repley_anser">
                                    <p>{j.row_title}</p>
                                    <p>{j.row_desc}</p>
                                </div>
                            </div>
                        </div>
                    )
                }
            })
        } else if (rightDatas.interactive_type == "button"){
            return newItem.map(j => {
                if (j.button_id == rightDatas.btn_id) {
                    return (
                        <div className="right_meg_box_new">
                            <div className="repley_box">
                                <div className="repley_data">
                                    <p>{item.body}</p>
                                </div>
                                <div className="repley_anser">
                                    <p>{j.title}</p>
                                </div>
                            </div>
                        </div>
                    )
                }
            })
        }
    }

    return (
        <div className='m-3'>
            {
                reportPre.data[0].map(i => {
                    if (i.block_type == "left") {
                        return (
                            <div className='m-3'>
                                <LeftBlock leftDatas={i} />
                            </div>
                        )
                    } else if (i.block_type == "right") {
                        return (
                            <div className='m-3'>
                                <RightBlock rightDatas={i} />
                            </div>
                        )
                    }
                })
            }
        </div>
    )
    
    
    

}